<div class="flex justify-content-center">
    @if (isLoading) {
        <p-progressSpinner></p-progressSpinner>
    }
</div>

<ng-container>
    @if (calendarOptions) {
        <full-calendar [options]="calendarOptions"></full-calendar>
    }
</ng-container>

